import {
    Component,
    Injector,
    OnInit,
    ViewEncapsulation
  } from '@angular/core';
  import { BsModalRef } from 'ngx-bootstrap/modal';
  import { forEach as _forEach, map as _map } from 'lodash-es';
  import { AppComponentBase } from '@shared/app-component-base';
import { QRCodeElementType, QRCodeComponent } from 'angularx-qrcode';
import { SafeUrl } from '@angular/platform-browser';
  
  @Component({
    selector: 'app-qrcode-dialog',
    templateUrl: './qrcode-dialog.component.html',
    styleUrls: ['./qrcode-dialog.component.css'],
    encapsulation: ViewEncapsulation.None
  })
  export class QrcodeDialogComponent extends AppComponentBase
    implements OnInit {
    
    value :string;
    title = 'qrCode';
    type: QRCodeElementType;
    public qrCodeDownloadLink: SafeUrl = "";

    constructor(
    injector: Injector,
    public bsModalRef: BsModalRef
    ) {
        super(injector);
    }
    
    ngOnInit(): void {
    
    }

    onChangeURL(url: SafeUrl) {
      this.qrCodeDownloadLink = url;
    }
  }
  